import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import errorName, { url } from "../base/Variables";
import { LazyAxios, catchError, getToken, handleRequest } from "../base";

const baseUrl = `${url}/api/v1/wholesale/inquiry`

const initialState = {
    'inquiry_loading': false,
    'inquiry_success': null,
    'inquiry_error': null,
    'inquiry_error_type': null,
    'inquiry_action': null,
    'all_inquiry': null,
    'all_inquiry_page': 1,
    'all_inquiry_last_page': false
}


const getAllInquiry = createAsyncThunk('getAllInquiry', async (page, { rejectWithValue }) => {
    try {
        const token = getToken()
        const axios = await LazyAxios()
        const request = await axios.get(`${baseUrl}/all/?page=${page}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
        console.log(request.data)
        return handleRequest(request, rejectWithValue)
    }
    catch (error) {
        return rejectWithValue(catchError(error))
    }
})


const wholesaleSlice = createSlice({
    name: 'wholesaleSlice',
    initialState: initialState,
    reducers: {
        wholesaleSliceDefault(state, action) {
            state.inquiry_loading = false
            state.inquiry_success = null
            state.inquiry_error = null
            state.inquiry_error_type = null
            state.inquiry_action = null
            state.all_inquiry = null
            state.all_inquiry_page = 1
            state.all_inquiry_last_page = false
        },
        inquiryDefault(state, action) {
            state.inquiry_error = null
            state.inquiry_error_type = null
            state.inquiry_success = null
        },
        // once inquiry placed then reset so that again inquiries will fetch
        resetAllInquiry(state, action) {
            state.all_inquiry = action.payload
            state.inquiry_loading = true
        },
        incAllInquiryPage(state, action) {
            state.all_inquiry_page = state.all_inquiry_page + 1
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllInquiry.pending, (state) => {
                state.inquiry_loading = true
                state.inquiry_error = null
                state.inquiry_error_type = null
                state.inquiry_success = null
            })
            .addCase(getAllInquiry.fulfilled, (state, action) => {
                state.inquiry_loading = false
                state.all_inquiry = state.all_inquiry ? [...state.all_inquiry, ...action.payload.data] : action.payload.data
            })
            .addCase(getAllInquiry.rejected, (state, action) => {
                action.payload.error_message === errorName.invalidPage ?
                    state.all_inquiry_last_page = true :
                    state.inquiry_error = action.payload.error_message
                state.inquiry_error_type = action.payload.type
                state.inquiry_loading = false
            })
    }
})

export default wholesaleSlice;
export { getAllInquiry }
export const { wholesaleSliceDefault, inquiryDefault, resetAllInquiry, incAllInquiryPage } = wholesaleSlice.actions